<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('yacht_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('yacht_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P005'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/0" class="resserve-button"> 예약신청 </router-link>-->
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="60" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <div>{{ $t('yacht_desc1') }}</div>
          <div v-html="$t('yacht_desc2')"></div>
          <div>{{ $t('yacht_desc3') }}</div>
          <div>{{ $t('yacht_desc4') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('yacht_common_title') }}</div>
          <div class="subDatail">
            <div>{{ $t('yacht_common_desc1') }}</div>
            <!--            <div>{{ $t('yacht_common_desc2') }}</div>
            <div>{{ $t('yacht_common_desc3') }}</div>-->
            <!--            <div>{{ $t('yacht_common_desc4') }}</div>-->
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('yacht_main_title') }}</div>
          <div class="row d-flex">
            <div v-for="(item, index) in sub_items" :key="index" class="col-lg-4 col-12 mb-4">
              <template>
                <div class="card">
                  <a :href="item.href">
                    <img class="card-img-top" :src="item.image" alt="Card image cap" style="padding: 10px"
                  /></a>
                  <div class="card-body">
                    <h5 class="card-title" style="letter-spacing: -0.02rem">{{ $t(item.title) }}</h5>
                    <p class="card-text" style="font-size: 0.8rem; word-break: keep-all; height: 7rem">
                      {{ $t(item.desc) }}
                    </p>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <!--          <div class="subDatail">-->
          <!--            <div>1. 오션투어 : 아름다운 경관이 펼쳐진 제주 남서부 대정 앞바다 투어 (돌고래 자생지)</div>-->
          <!--            <div>-->
          <!--              2. 송악산 투어 : 산방산 남쪽 바다를 수놓는 송악산 일대의 형제섬, 가파도, 마라도의 비경이 펼쳐진 제주 남쪽-->
          <!--              바다 투어-->
          <!--            </div>-->
          <!--            <div>-->
          <!--              3. 차귀도 투어 : 차귀도의 수려한 자연경관과 깎아놓은 듯한 해안절벽, 기암괴석의 절경이 펼쳐진 제주 서쪽-->
          <!--              바다 투어-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="rowSpace"></div>

          <table class="web table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan="2">{{ $t('yacht_table1_tr2_td1') }}</td>
                <td>{{ $t('yacht_table1_tr2_td2') }}</td>
                <td rowspan="6">{{ $t('yacht_table1_tr2_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td4') }}</td>
                <td>{{ $t('yacht_table1_tr2_td5') }}</td>
                <td rowspan="6" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>

              <tr>
                <td>{{ $t('yacht_table1_tr3_td1') }}</td>
                <td>{{ $t('yacht_table1_tr3_td2') }}</td>
                <td>{{ $t('yacht_table1_tr3_td3') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('yacht_table1_tr4_td1') }}</td>
                <td>{{ $t('yacht_table1_tr4_td2') }}</td>
                <td>{{ $t('yacht_table1_tr4_td3') }}</td>
                <td>{{ $t('yacht_table1_tr4_td4') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr5_td1') }}</td>
                <td>{{ $t('yacht_table1_tr5_td2') }}</td>
                <td>{{ $t('yacht_table1_tr5_td3') }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('yacht_table1_tr6_td1') }}</td>
                <td>{{ $t('yacht_table1_tr6_td2') }}</td>
                <td>{{ $t('yacht_table1_tr6_td3') }}</td>
                <td>{{ $t('yacht_table1_tr6_td4') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr7_td1') }}</td>
                <td>{{ $t('yacht_table1_tr7_td2') }}</td>
                <td>{{ $t('yacht_table1_tr7_td3') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td class="subTable2">{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr2_td1') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr2_td2') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr2_td4') }}</td>
              </tr>
              <tr>
                <td class="subTable2">{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr2_td5') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="subTable3">{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
              <tr>
                <td colspan="2" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr2_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr3_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr3_td3') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="subTable3">{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
              <tr>
                <td colspan="2" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr4_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr4_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr4_td4') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="subTable3">{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
              <tr>
                <td colspan="2" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr4_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr5_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr5_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr5_td3') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="subTable3">{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
              <tr>
                <td colspan="2" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr6_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr6_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr6_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr6_td4') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="subTable3">{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
              <tr>
                <td colspan="2" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-bordered subTable">
            <tbody>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td1') }}</td>
                <td>{{ $t('yacht_table1_tr6_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td2') }}</td>
                <td>{{ $t('yacht_table1_tr7_td1') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td3') }}</td>
                <td>{{ $t('yacht_table1_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td4') }}</td>
                <td>{{ $t('yacht_table1_tr7_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table1_tr1_td5') }}</td>
                <td>{{ $t('yacht_table1_tr7_td3') }}</td>
              </tr>
              <tr>
                <td colspan="2" class="subTable3">{{ $t('yacht_table1_tr1_td6') }}</td>
              </tr>
              <tr>
                <td colspan="2" v-html="$t('yacht_table1_tr2_td6')"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <!--        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('yacht_addition_title') }}</div>

          <GallerySlideCarousels :slides="addition_slides" :slide-count="4" :thumb-slide-width="50" />

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td>{{ $t('yacht_table2_tr1_td1') }}</td>
                <td colspan="2">{{ $t('yacht_table2_tr1_td2') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('yacht_table2_tr2_td1') }}</td>
                <td>{{ $t('yacht_table2_tr2_td2') }}</td>
                <td rowspan="6">{{ $t('yacht_table2_tr2_td3') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table2_tr3_td1') }}</td>
                <td>{{ $t('yacht_table2_tr3_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table2_tr4_td1') }}</td>
                <td>{{ $t('yacht_table2_tr4_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table2_tr5_td1') }}</td>
                <td>{{ $t('yacht_table2_tr5_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table2_tr6_td1') }}</td>
                <td>{{ $t('yacht_table2_tr6_td2') }}</td>
              </tr>
              <tr>
                <td>{{ $t('yacht_table2_tr7_td1') }}</td>
                <td>{{ $t('yacht_table2_tr7_td2') }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="rowSpace"><hr /></div>-->
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('yacht_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('yacht_etc_desc1') }}</div>
            <div>{{ $t('yacht_etc_desc2') }}</div>
            <div>{{ $t('yacht_etc_desc3') }}</div>
            <div>{{ $t('yacht_etc_desc4') }}</div>
            <div>{{ $t('yacht_etc_desc5') }}</div>
            <!--            <div>{{ $t('yacht_etc_desc6') }}</div>-->
            <div>{{ $t('yacht_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P005'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
          <!--          <router-link to="/p/Reservpleisure/0" class="resserve-button"> 예약신청 </router-link>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'luxuryyacht',
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/luxuryyacht_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/luxuryyacht_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/luxuryyacht_main_03.jpg')},
        {image: require('@/assets/images/pleisure/program/luxuryyacht_main_04.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/luxuryyacht_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/luxuryyacht_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/luxuryyacht_option_03.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_option_01.jpg')},
      ],
      sub_items: [
        {
          title: 'yacht_mainp_title1',
          desc: 'yacht_mainp_desc1',
          image: require('@/assets/images/pleisure/program/luxuryyacht_thumb_01.jpg'),
        },
        {
          title: 'yacht_mainp_title2',
          desc: 'yacht_mainp_desc2',
          image: require('@/assets/images/pleisure/program/luxuryyacht_thumb_02.jpg'),
        },
        {
          title: 'yacht_mainp_title3',
          desc: 'yacht_mainp_desc3',
          image: require('@/assets/images/pleisure/program/luxuryyacht_thumb_03.jpg'),
        },
      ],
    };
  },
  components: {Breadcrumb, GallerySlideCarousels},
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}
.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/luxuryyacht_headerimage.jpg');
}
@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
  .card {
    height: 26rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "yacht_title": "프라이빗 럭셔리요트",
    "yacht_subtitle": "제주 최고의 요트에서 즐기는 스페셜 럭셔리 제주 여행",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "yacht_desc1": "제주 최고의 요트 위에서 아름다운 바다를 느껴보세요.",
    "yacht_desc2": "아름다운 제주 자연의 신비와 요트가 만들어낸 물살을 유영하는 돌고래의 모습<br/>제주 최남단 송악산의 아름다운 절경 등 색다른 아름다움을 느끼실 수 있습니다.",
    "yacht_desc3": "프라이빗한 선상 와인 파티와 함께 소중한 사람들과 제주 바다의 낭만과 재미, 프라이빗한 여유를 즐겨보세요.",
    "yacht_desc4": "※ 요트의 종류에 따라 체험 내용 및 코스는 상이합니다.",
    "yacht_common_title": "공통 의전 및 서비스",
    "yacht_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "yacht_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "yacht_common_desc3": "- 어메니티, 미니바 제공",
    "yacht_common_desc4": "- F&B 세트 제공",
    "yacht_main_title": "메인 프로그램",
    "yacht_mainp_title1": "오션투어",
    "yacht_mainp_desc1": "아름다운 경관이 펼쳐진 제주 남서부 대정 앞바다 투어 (돌고래 자생지)",
    "yacht_mainp_title2": "송악산 투어",
    "yacht_mainp_desc2": "산방산 남쪽 바다를 수놓는 송악산 일대의 형제섬, 가파도, 마라도의 비경이 펼쳐진 제주 남쪽 바다 투어",
    "yacht_mainp_title3": "차귀도 투어",
    "yacht_mainp_desc3": "차귀도의 수려한 자연경관과 깎아놓은 듯한 해안 절벽, 기암괴석의 절경이 펼쳐진 제주 서쪽 바다 투어",
    "yacht_table1_tr1_td1": "옵션",
    "yacht_table1_tr1_td2": "시간",
    "yacht_table1_tr1_td3": "최대인원",
    "yacht_table1_tr1_td4": "소요시간",
    "yacht_table1_tr1_td5": "요금(2인기준)",
    "yacht_table1_tr1_td6": "추가옵션",
    "yacht_table1_tr2_td1": "오션투어",
    "yacht_table1_tr2_td2": "70분",
    "yacht_table1_tr2_td3": "10인",
    "yacht_table1_tr2_td4": "2.5H",
    "yacht_table1_tr2_td5": "2,200,000",
    "yacht_table1_tr2_td6": "※ 인원추가 +100,000 원 / 인<br/>※ 선셋 타임 +200,000 원",
    "yacht_table1_tr3_td1": "90분",
    "yacht_table1_tr3_td2": "3H",
    "yacht_table1_tr3_td3": "2,500,000",
    "yacht_table1_tr4_td1": "송악산투어",
    "yacht_table1_tr4_td2": "70분",
    "yacht_table1_tr4_td3": "2.5H",
    "yacht_table1_tr4_td4": "1,900,000",
    "yacht_table1_tr5_td1": "90분",
    "yacht_table1_tr5_td2": "3H",
    "yacht_table1_tr5_td3": "2,200,000",
    "yacht_table1_tr6_td1": "차귀도투어",
    "yacht_table1_tr6_td2": "60분",
    "yacht_table1_tr6_td3": "2.5H",
    "yacht_table1_tr6_td4": "1,700,000",
    "yacht_table1_tr7_td1": "90분",
    "yacht_table1_tr7_td2": "3H",
    "yacht_table1_tr7_td3": "2,000,000",
    "yacht_addition_title": "추가옵션",
    "yacht_table2_tr1_td1": "구분",
    "yacht_table2_tr1_td2": "옵션(2인기준)",
    "yacht_table2_tr2_td1": "150,000",
    "yacht_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "yacht_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "yacht_table2_tr3_td1": "200,000",
    "yacht_table2_tr3_td2": "메디컬 스파(바디)",
    "yacht_table2_tr4_td1": "350,000",
    "yacht_table2_tr4_td2": "오모로비짜 스파(90분)",
    "yacht_table2_tr5_td1": "400,000",
    "yacht_table2_tr5_td2": "본에스티스 스파(90분)",
    "yacht_table2_tr6_td1": "500,000",
    "yacht_table2_tr6_td2": "스냅(요트)",
    "yacht_table2_tr7_td1": "플라워 세팅",
    "yacht_table2_tr7_td2": "300,000 / 500,000 / 700,000",
    "yacht_etc_title": "기타사항",
    "yacht_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "yacht_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "yacht_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "yacht_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "yacht_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "yacht_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "yacht_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "yacht_title": "Private luxury yacht",
    "yacht_subtitle": "Special and luxury journey on the best yacht in Jeju Island.",
    "prev_button": "Previous",
    "reserve_button": "Book now",
    "yacht_desc1": "Experience the beautiful sea on the best yacht in Jeju.",
    "yacht_desc2": "You can find the unique beauty of Jeju while watching dancing dolphins in the waves created by the yacht and looking at the beautiful scenery of the Jeju southernmost Songaksan Mountain.",
    "yacht_desc3": "With a private wine party on board, enjoy the romance, fun, and private relaxation of the Jeju Sea with your loved ones.",
    "yacht_desc4": "※ Experience programs or courses may vary depending on the type of yacht.",
    "yacht_common_title": "Common escort service and other services",
    "yacht_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "yacht_common_desc2": "- Care service by the PINX escort manager",
    "yacht_common_desc3": "- Free amenities and minibar",
    "yacht_common_desc4": "- Complimentary F&B sets",
    "yacht_main_title": "Main Program",
    "yacht_mainp_title1": "Ocean Tour",
    "yacht_mainp_desc1": "A tour around the coast of Daejeong in the southwestern part of Jeju with beautiful scenery (dolphin habitat)",
    "yacht_mainp_title2": "Songaksan Mountain Tour",
    "yacht_mainp_desc2": "A tour around the southern sea of Jeju Island with a marvelous view of Hyeongjeseom Island, Gapado, and Marado Island near the area of Songaksan Mountain, which embroiders the scenery in the southern sea of Sanbangsan Mountain.",
    "yacht_mainp_title3": "Chagwido Island Tour",
    "yacht_mainp_desc3": "A tour around the western sea of Jeju to look around beautiful natural scenery of Chagwido Island, carved coastal cliffs, and superb views of strange rocks and bizarre stones.",
    "yacht_table1_tr1_td1": "Option",
    "yacht_table1_tr1_td2": "Running time",
    "yacht_table1_tr1_td3": "Maximum Occupancy",
    "yacht_table1_tr1_td4": "Total Time",
    "yacht_table1_tr1_td5": "Fare(for 2people)",
    "yacht_table1_tr1_td6": "Additional option",
    "yacht_table1_tr2_td1": "Ocean Tour",
    "yacht_table1_tr2_td2": "70 min",
    "yacht_table1_tr2_td3": "10 People",
    "yacht_table1_tr2_td4": "2.5H",
    "yacht_table1_tr2_td5": "KRW 2,200,000",
    "yacht_table1_tr2_td6": "※ Additional passenger +KRW 100,000  / 1 person<br/>※ Sunset time +KRW 200,000",
    "yacht_table1_tr3_td1": "90 min",
    "yacht_table1_tr3_td2": "3H",
    "yacht_table1_tr3_td3": "KRW 2,500,000",
    "yacht_table1_tr4_td1": "Songaksan Mountain Tour",
    "yacht_table1_tr4_td2": "70 min",
    "yacht_table1_tr4_td3": "2.5H",
    "yacht_table1_tr4_td4": "KRW 1,900,000",
    "yacht_table1_tr5_td1": "90 min",
    "yacht_table1_tr5_td2": "3H",
    "yacht_table1_tr5_td3": "KRW 2,200,000",
    "yacht_table1_tr6_td1": "Chagwido Island Tour",
    "yacht_table1_tr6_td2": "60 min",
    "yacht_table1_tr6_td3": "2.5H",
    "yacht_table1_tr6_td4": "KRW 1,700,000",
    "yacht_table1_tr7_td1": "90 min",
    "yacht_table1_tr7_td2": "3H",
    "yacht_table1_tr7_td3": "KRW 2,000,000",
    "yacht_addition_title": "Additional Option",
    "yacht_table2_tr1_td1": "Fare",
    "yacht_table2_tr1_td2": "Option(2 people)",
    "yacht_table2_tr2_td1": "KRW 150,000",
    "yacht_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min)",
    "yacht_table2_tr2_td3": "※ More than 3 people, please contact us",
    "yacht_table2_tr3_td1": "KRW 200,000",
    "yacht_table2_tr3_td2": "Medical Spa(Body)",
    "yacht_table2_tr4_td1": "KRW 350,000",
    "yacht_table2_tr4_td2": "Omorovicza Spa(90min)",
    "yacht_table2_tr5_td1": "KRW 400,000",
    "yacht_table2_tr5_td2": "Vonestis Spa(90min)",
    "yacht_table2_tr6_td1": "KRW 500,000",
    "yacht_table2_tr6_td2": "Snapshot(Yacht)",
    "yacht_table2_tr7_td1": "Flower service",
    "yacht_table2_tr7_td2": "KRW 300,000 / 500,000 / 700,000",
    "yacht_etc_title": "Others",
    "yacht_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "yacht_etc_desc2": "※ In some cases, minors may need a guardian.",
    "yacht_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "yacht_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "yacht_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "yacht_etc_desc6": "※ Traveler's insurance is included in the product.",
    "yacht_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "yacht_title": "프라이빗 럭셔리요트",
    "yacht_subtitle": "제주 최고의 요트에서 즐기는 스페셜 럭셔리 제주 여행",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "yacht_desc1": "제주 최고의 요트 위에서 아름다운 바다를 느껴보세요.",
    "yacht_desc2": "아름다운 제주 자연의 신비와 요트가 만들어낸 물살을 유영하는 돌고래의 모습",
    "yacht_desc3": "제주 최남단 송악산의 아름다운 절경 등 색다른 아름다움을 느끼실 수 있습니다.",
    "yacht_desc4": "프라이빗한 선상 와인 파티와 함께 소중한 사람들과 제주 바다의 낭만과 재미, 프라이빗한 여유를 즐겨보세요.",
    "yacht_desc5": "※ 요트의 종류에 따라 체험 내용 및 코스는 상이합니다.",
    "yacht_common_title": "공통 의전 및 서비스",
    "yacht_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "yacht_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "yacht_common_desc3": "- 어메니티, 미니바 제공",
    "yacht_common_desc4": "- F&B 세트 제공",
    "yacht_main_title": "메인 프로그램",
    "yacht_mainp_title1": "오션투어",
    "yacht_mainp_desc1": "아름다운 경관이 펼쳐진 제주 남서부 대정 앞바다 투어 (돌고래 자생지)",
    "yacht_mainp_title2": "송악산 투어",
    "yacht_mainp_desc2": "산방산 남쪽 바다를 수놓는 송악산 일대의 형제섬, 가파도, 마라도의 비경이 펼쳐진 제주 남쪽 바다 투어",
    "yacht_mainp_title3": "차귀도 투어",
    "yacht_mainp_desc3": "차귀도의 수려한 자연경관과 깎아놓은 듯한 해안 절벽, 기암괴석의 절경이 펼쳐진 제주 서쪽 바다 투어",
    "yacht_table1_tr1_td1": "옵션",
    "yacht_table1_tr1_td2": "시간",
    "yacht_table1_tr1_td3": "최대인원",
    "yacht_table1_tr1_td4": "소요시간",
    "yacht_table1_tr1_td5": "요금(2인기준)",
    "yacht_table1_tr1_td6": "추가옵션",
    "yacht_table1_tr2_td1": "오션투어",
    "yacht_table1_tr2_td2": "70분",
    "yacht_table1_tr2_td3": "10인",
    "yacht_table1_tr2_td4": "2.5H",
    "yacht_table1_tr2_td5": "2,200,000",
    "yacht_table1_tr2_td6": "※ 인원추가 +100,000 원 / 인<br/>※ 선셋 타임 +200,000 원",
    "yacht_table1_tr3_td1": "90분",
    "yacht_table1_tr3_td2": "3H",
    "yacht_table1_tr3_td3": "2,500,000",
    "yacht_table1_tr4_td1": "송악산투어",
    "yacht_table1_tr4_td2": "70분",
    "yacht_table1_tr4_td3": "2.5H",
    "yacht_table1_tr4_td4": "1,900,000",
    "yacht_table1_tr5_td1": "90분",
    "yacht_table1_tr5_td2": "3H",
    "yacht_table1_tr5_td3": "2,200,000",
    "yacht_table1_tr6_td1": "차귀도투어",
    "yacht_table1_tr6_td2": "60분",
    "yacht_table1_tr6_td3": "2.5H",
    "yacht_table1_tr6_td4": "1,700,000",
    "yacht_table1_tr7_td1": "90분",
    "yacht_table1_tr7_td2": "3H",
    "yacht_table1_tr7_td3": "2,000,000",
    "yacht_addition_title": "추가옵션",
    "yacht_table2_tr1_td1": "구분",
    "yacht_table2_tr1_td2": "옵션(2인기준)",
    "yacht_table2_tr2_td1": "150,000",
    "yacht_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "yacht_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "yacht_table2_tr3_td1": "200,000",
    "yacht_table2_tr3_td2": "메디컬 스파(바디)",
    "yacht_table2_tr4_td1": "350,000",
    "yacht_table2_tr4_td2": "오모로비짜 스파(90분)",
    "yacht_table2_tr5_td1": "500,000",
    "yacht_table2_tr5_td2": "스냅(요트)",
    "yacht_table2_tr6_td1": "플라워 세팅",
    "yacht_table2_tr6_td2": "300,000 / 500,000 / 700,000",
    "yacht_etc_title": "기타사항",
    "yacht_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "yacht_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "yacht_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "yacht_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "yacht_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "yacht_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "yacht_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
